export default __webpack_public_path__ + "assets/column_container_widget.c813d11259ceeee6a301d9e394d225b7.svg";